import React from 'react';

const APP_STORE_URL = 'https://apps.apple.com/us/app/istanbultango/id6767050311';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.istanbultango.student';

const features = [
  { icon: '📅', text: 'Ders programını görüntüle' },
  { icon: '✅', text: 'Yoklama geçmişini takip et' },
  { icon: '💳', text: 'Kredi bakiyeni yönet' },
  { icon: '🔔', text: 'Anlık bildirimler al' },
  { icon: '🎓', text: 'Eğitmen ve ders bilgilerine ulaş' },
];

function AppleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
    </svg>
  );
}

function GooglePlayIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3.18 23.76c.3.17.64.24.99.2l12.6-12.6-3.18-3.18L3.18 23.76zm-1.7-19.98C1.18 4.18 1 4.63 1 5.14v13.72c0 .51.18.96.48 1.36l.07.07L8.64 13.2v-.4L1.55 5.71l-.07.07zm19.73 8.18l-2.13-1.23-3.14 3.14 3.14 3.14 2.16-1.25c.62-.36.62-.94 0-1.8h-.03zm-19.06 9.7L13.9 11.8 10.76 8.66.15 21.66z"/>
    </svg>
  );
}

export default function Indir() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0a0a0a',
      color: '#fff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>

      {/* Hero */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 24px 40px',
        textAlign: 'center',
        maxWidth: 480,
        width: '100%',
      }}>

        {/* Logo */}
        <div style={{
          width: 96,
          height: 96,
          borderRadius: 22,
          backgroundColor: '#111',
          border: '1px solid #2a2a2a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 28,
          boxShadow: '0 8px 32px rgba(196, 30, 58, 0.2)',
        }}>
          <span style={{
            fontSize: 52,
            fontWeight: 900,
            color: '#C41E3A',
            lineHeight: 1,
            letterSpacing: -2,
          }}>T</span>
        </div>

        {/* App adı */}
        <h1 style={{
          fontSize: 32,
          fontWeight: 800,
          margin: '0 0 8px',
          letterSpacing: -0.5,
          color: '#fff',
        }}>
          istanbulTANGO
        </h1>

        <p style={{
          fontSize: 15,
          color: '#888',
          margin: '0 0 40px',
          lineHeight: 1.5,
        }}>
          İstanbul'un tango topluluğu için<br />
          ders, yoklama ve ödeme yönetimi
        </p>

        {/* İndirme butonları */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          width: '100%',
          maxWidth: 320,
          marginBottom: 48,
        }}>

          {/* App Store */}
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 12,
              backgroundColor: '#fff',
              color: '#000',
              borderRadius: 14,
              padding: '14px 24px',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: 15,
              transition: 'opacity 0.15s',
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = '0.9')}
            onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
          >
            <AppleIcon />
            <span>
              <span style={{ display: 'block', fontSize: 10, fontWeight: 400, opacity: 0.6, lineHeight: 1, marginBottom: 2 }}>
                App Store'dan İndir
              </span>
              iPhone & iPad
            </span>
          </a>

          {/* Google Play */}
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 12,
              backgroundColor: '#C41E3A',
              color: '#fff',
              borderRadius: 14,
              padding: '14px 24px',
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: 15,
              transition: 'opacity 0.15s',
            }}
            onMouseEnter={e => (e.currentTarget.style.opacity = '0.9')}
            onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
          >
            <GooglePlayIcon />
            <span>
              <span style={{ display: 'block', fontSize: 10, fontWeight: 400, opacity: 0.8, lineHeight: 1, marginBottom: 2 }}>
                Google Play'den İndir
              </span>
              Android
            </span>
          </a>
        </div>

        {/* Ayraç */}
        <div style={{
          width: 40,
          height: 1,
          backgroundColor: '#2a2a2a',
          marginBottom: 36,
        }} />

        {/* Özellikler */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
          width: '100%',
          maxWidth: 280,
        }}>
          {features.map(({ icon, text }) => (
            <div key={text} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
            }}>
              <span style={{ fontSize: 18, width: 28, textAlign: 'center' }}>{icon}</span>
              <span style={{ fontSize: 14, color: '#aaa' }}>{text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div style={{
        padding: '24px',
        textAlign: 'center',
        borderTop: '1px solid #1a1a1a',
        width: '100%',
      }}>
        <p style={{ margin: 0, color: '#444', fontSize: 12 }}>
          © {new Date().getFullYear()} istanbulTANGO · Meet Sanat Ltd
          <span style={{ margin: '0 8px' }}>·</span>
          <a href="/gizlilik" style={{ color: '#555', textDecoration: 'none' }}>Gizlilik Politikası</a>
        </p>
      </div>

    </div>
  );
}
